import { render, staticRenderFns } from "./CodeEqual0.vue?vue&type=template&id=9897e58c"
import script from "./CodeEqual0.vue?vue&type=script&lang=js"
export * from "./CodeEqual0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports